"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LoadGoogleTag", {
  enumerable: true,
  get: function get() {
    return _load.LoadGoogleTag;
  }
});
Object.defineProperty(exports, "TrackGoogleTagPageView", {
  enumerable: true,
  get: function get() {
    return _track.TrackGoogleTagPageView;
  }
});
Object.defineProperty(exports, "TrackGoogleTag", {
  enumerable: true,
  get: function get() {
    return _track.TrackGoogleTag;
  }
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _Tracker2 = _interopRequireDefault(require("../common/Tracker"));

var _load = require("./load");

var _track = require("./track");

var _Console = require("../common/Console");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GoogleTag =
/*#__PURE__*/
function (_Tracker) {
  _inherits(GoogleTag, _Tracker);

  function GoogleTag() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GoogleTag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GoogleTag)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "app_name", document.title);

    return _this;
  }

  _createClass(GoogleTag, [{
    key: "initialise",

    /**
     * When the component is initialised (called by teh componentdidmount)
     * @returns {void}
     */
    value: function initialise() {
      var options = this.props.options;
      var trackingId = options.trackingId;

      if (!trackingId) {
        (0, _Console.warn)("Trakcing Id is required for GoogleTag to track pageviews");
      }

      if (!window.gtag && options) {
        (0, _load.LoadGoogleTag)(options);

        if (options.app_name) {
          this.app_name = options.app_name;
        }
      }
    }
    /**
     * combines and sends to the google library the pageView
     * @param {string} pathname of the current url string
     * @param {string} search search params from the url
     * @returns {void}
     */

  }, {
    key: "sendPageChange",
    value: function sendPageChange(pathname) {
      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var page = pathname + search;
      var trackingId = this.props.options.trackingId;

      if (!trackingId) {
        return (0, _Console.warn)('TrackingId required for gtag to work');
      }

      return (0, _track.TrackGoogleTagPageView)(page, trackingId);
    }
  }]);

  return GoogleTag;
}(_Tracker2.default);

var _default = (0, _reactRouter.withRouter)(GoogleTag);

exports.default = _default;